import React, { useEffect } from 'react';
import { arPdf } from '../../utils/filtyper';

/**
 * Fullskärmsvisning av en enskild bild från en vanlig URL.
 *
 * Skiljer sig från features/sharepoint/ImageLightbox, som löser ett annat
 * problem: den hämtar authade blobbar och bläddrar mellan filer. Den här visar
 * en bild som redan har en publik adress — exempelbilderna i IA-prislistan.
 *
 * Stängs med krysset, klick utanför bilden eller Escape.
 *
 * Ligger på z-60 för att hamna ovanför modalerna i portalen, som ligger på z-50.
 */
const Bildvisare = ({ src, alt = '', onClose }) => {
  useEffect(() => {
    const vidTangent = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', vidTangent);
    return () => window.removeEventListener('keydown', vidTangent);
  }, [onClose]);

  if (!src) return null;

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={alt || 'Bild'}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
        title="Stäng (Esc)"
      >
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      {/* Exempelbilagan i IA-prislistan är ibland en PDF — ett prisexempel med
          flera sidor går inte att få till som en bild. Då renderas den i
          webbläsarens egen visare, som ger zoom, bläddring och utskrift gratis.
          S3 serverar filen med rätt Content-Type och utan download-disposition
          (utils/s3Upload.js), så den visas inline. */}
      {arPdf(src) ? (
        <iframe
          src={src}
          title={alt || 'PDF'}
          className="w-[92vw] h-[85vh] rounded-xl shadow-2xl bg-white"
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <img
          src={src}
          alt={alt}
          className="max-w-full max-h-[85vh] rounded-xl shadow-2xl object-contain"
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
};

export default Bildvisare;
